import React from 'react'

import Modal from 'src/components/modal/modal'
import { CLASS_PREFIX } from 'src/constants'

import { ProjectInfoCard } from 'src/components/projects/learn_more/project_info_card'
import { ProjectSteps } from 'src/components/projects/learn_more/project_steps'

import Icon from 'src/components/forms/icon/icon'
import { KoerberIcon } from 'src/components/icons/projects/public-participation/koerber'
import { MethodIcon } from 'src/components/icons/projects/public-participation/method'
import { textResources } from 'src/lang/de'
import { COLOR_TYPE_WHITE } from 'src/utils/color'
import GradientLink from '../gradient_link/gradient_link'
import * as learnMoreHero from './learn-more-hero-image.jpg'
import './projects_learn_more_modal.scss'

const cls = `${CLASS_PREFIX}project-learn-more-modal`

const t = textResources.projects

type IProps = {
  onClose: () => void;
  openCreateProject?: () => void;
};

export const ProjectsLearnMoreModal: React.FC<IProps> = ({
  onClose,
  openCreateProject
}) => (
  <Modal autoSize onClose={onClose} customClassNames={`${cls}__learn-body`}>
    <div className={`${cls}__learn`}>
      <div className={`${cls}__hero`}>
        <img src={learnMoreHero} alt="" loading="lazy" />
        <div className={`${cls}__overlay`}>
          <h2 className={`${cls}__title`}>{t.learnMoreModal.title}</h2>
        </div>
      </div>

      <p className={`${cls}__intro`}>
        {t.learnMoreModal.introPart1}
        {t.learnMoreModal.introPart2
          ? (
            <>
              <br />
              {t.learnMoreModal.introPart2}
            </>
          )
          : null}
      </p>

      <div className={`${cls}__grid`}>
        <ProjectInfoCard
          icon={<MethodIcon />}
          content={<p>{t.learnMoreModal.deineIdee.text}</p>}
          title={t.learnMoreModal.deineIdee.title}
        />
        <ProjectInfoCard
          icon={<KoerberIcon />}
          content={<p>{t.learnMoreModal.deinePartner.text}</p>}
          title={t.learnMoreModal.deinePartner.title}
        />
      </div>

      <ProjectSteps
        title={t.learnMoreModal.steps.title}
        items={t.learnMoreModal.steps.items}
      />

      <div className={`${cls}__funding`}>
        <div className={`${cls}__funding-icon`}>
          <KoerberIcon />
        </div>
        <p className={`${cls}__funding-text`}>
          {t.learnMoreModal.funding}{' '}
          <GradientLink
            href={t.learnMoreModal.fundingLink}
            target="_blank"
            rel="noreferrer noopener"
          >
            {t.learnMoreModal.fundingLinkText}
          </GradientLink>
        </p>
      </div>

      <p className={`${cls}__support`}>
        {t.learnMoreModal.support}{' '}
        <GradientLink href={`mailto:${t.learnMoreModal.supportEmail}`}>
          {t.learnMoreModal.supportEmail}
        </GradientLink>{' '}
        {t.learnMoreModal.supportSuffix}
      </p>

      <div className={`${cls}__cta-row`}>
        <div className={`${cls}__cta-hint`}>
          <div className={`${cls}__cta-title`}>
            {t.learnMoreModal.cta.title}
          </div>
          <div className={`${cls}__cta-sub`}>{t.learnMoreModal.cta.sub}</div>
        </div>
        {openCreateProject
          ? (
            <button
              type="button"
              className={`${cls}__primary`}
              onClick={() => {
                onClose()
                openCreateProject()
              }}
            >
              <Icon name={'plus'} size={18} color={COLOR_TYPE_WHITE} />
              {t.learnMoreModal.cta.button}
            </button>
          )
          : null}
      </div>
    </div>
  </Modal>
)
